import React, { useEffect, useRef, useState } from "react";
import { Box, Skeleton } from "@mui/material";

const DEFAULT_ROOT_MARGIN = "240px 0px";

export default function ClientPortalLazyMedia({
  children,
  minHeight = 56,
  placeholder = null,
  rootMargin = DEFAULT_ROOT_MARGIN,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || visible) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [visible, rootMargin]);

  const fallback =
    placeholder ?? (
      <Skeleton
        variant="rounded"
        height={minHeight}
        sx={{ borderRadius: 1, bgcolor: "action.hover" }}
      />
    );

  return (
    <Box ref={ref} sx={{ minHeight: visible ? undefined : minHeight, width: "100%" }}>
      {visible ? children : fallback}
    </Box>
  );
}
